import React from 'react';
import { useDrag } from 'react-dnd';
import { useDispatch, useSelector } from 'react-redux';
import ComponentItem from 'components/ComponentItem';
import { IComponentItemOwnProps } from 'components/ComponentItem/models';
import { DragSourceType, LayoutType } from 'const';
import { toggleDragState } from 'containers/App/actions';
import { isReferenceCitationElementOnArtboard as isReferenceCitationElementOnArtboardSelector } from 'containers/Layouts/selectors';
import { EmptyLayoutDragObject } from 'models';

const LayoutItem: React.FC<IComponentItemOwnProps> = (props) => {
  const dispatch = useDispatch();
  const isReferenceCitationElementOnArtboard = useSelector(isReferenceCitationElementOnArtboardSelector);
  const { type, size } = props;
  const dragSourceType = DragSourceType.LAYOUT;
  const [{ isDragging }, dragRef] = useDrag<EmptyLayoutDragObject, void, { isDragging: boolean }>({
    type: dragSourceType,
    item: () => {
      dispatch(toggleDragState(dragSourceType, type));

      return {
        type: type as LayoutType,
        size,
      };
    },
    end: () => {
      dispatch(toggleDragState());
    },
    canDrag() {
      return !(type === LayoutType.REFERENCE_CITATION_ELEMENT && isReferenceCitationElementOnArtboard);
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return <ComponentItem {...props} connectDragSource={dragRef} isDragging={isDragging} />;
};

export default LayoutItem;
